import { createFileRoute } from '@tanstack/react-router'
import OportunidadeDetailPage from '@/pages/oportunidades/oportunidade-detail'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota index para /dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId
// Renderizada quando acessar diretamente /dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/',
)({
  component: function OportunidadeDetailRoute() {
    const { dashboardId, funilValue, oportunidadeId } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.CRM_ALL, CAPABILITIES.CRM_OWN]}
        dashboardId={dashboardId}
      >
        <OportunidadeDetailPage
          oportunidadeId={oportunidadeId}
          dashboardId={dashboardId}
          funilValue={funilValue}
        />
      </ProtectedRoute>
    )
  },
})
